import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Helpers } from '../helpers/helpersDate';
import { SurveyAudiences } from 'src/Models/SurveyAudiences';
import { Surveys } from 'src/Models/Surveys';
import { SurveyService } from '../service/survey.service';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QueryParamsUtils } from './queryParamsUtils';
import { finishFormEnum } from 'src/Models/Enum/FinishFormEnum';
import { SurveysResponse } from 'src/Models/SurveysResponse';
import { requiredConditionalValidator, requiredOthers } from 'src/app/shared/validator/requiredConditionalValidator';
import { Questions } from 'src/Models/Questions';
import { validCustomValidators } from 'src/app/shared/validator/validCustomValidators';
import { EnumQuestion } from 'src/Models/Enum/EnumQuestions';
import { ArrayMatrizItems, MatrizObj } from 'src/Models/AnswersOBJ/MatrizObj';
import { HelpersSettings } from '../helpers/helpersSettings';

@Injectable({
  providedIn: 'root'
})
export class FormUtils {
  device: any
  deviceDetector: DeviceDetectorService
  queryParamsUtils: QueryParamsUtils
  router: Router
  fb: FormBuilder
  form: FormGroup
  survey: Surveys;
  surveyService: SurveyService;
  formBuilder: FormBuilder;
  surveyNotValid: boolean = false;

  constructor(surveyService: SurveyService, form: FormGroup, queryParamsUtils: QueryParamsUtils,
    fb: FormBuilder, router: Router, deviceDetector: DeviceDetectorService) {
    this.surveyService = surveyService
    this.form = form
    this.formBuilder = fb
    this.router = router
    this.queryParamsUtils = queryParamsUtils
    this.deviceDetector = deviceDetector
    this.getDevice();
    window.addEventListener('online', this.syncOfflineResponses.bind(this));
  }

  createFormPliQ(): FormGroup {
    this.form = this.formBuilder.group({
      fk_survey: [this.survey.id_survey],
      participant_key: ['', Validators.required],
      name_key: [''],
      name: ['', Validators.required],
      responses: this.formBuilder.group({ data: this.responsesArray() }),
      nps_value: [0],
      nps_feedback: [''],
      tags: [null],
      referral_share_code: [null],
      abandonment: [false],
      fk_audience: [''],
      anonymous: [null],
      device_info: [JSON.stringify(this.device)],
      comments: [null],
      key_attendance: [null],
      fk_contact: [null],
      route_response: [null],
      fk_status_referral: [null],
      point_indicated: [null],
      properties: [null],
      url_redirected: [null],
      termuse: [false, Validators.requiredTrue],
      termuse2: [false, Validators.requiredTrue],
    });

    return this.form
  }

  responsesArray() {
    let formArray = this.formBuilder.array([]);
    if (this.survey.questions.length > 0) {
      this.survey.questions.forEach(question => {
        formArray.push(this.newResponse(question))
      });
    }
    return formArray;
  }

  newResponse(question: Questions) {
    return this.formBuilder.group({
      fk_question: [question.id_question],
      value: this.valueConfigByType(question),
      fk_type_question: [question.fk_type_question],
      answers: [null],
      data_response: [Helpers.date2str(new Date(), "yyyy-MM-dd hh:mm:ss")]
    });
  }

  valueConfigByType(question: Questions) {
    switch (question.fk_type_question) {
      case EnumQuestion.Matriz:
        return this.formMatrizConfig(question)
      case EnumQuestion.Checkboxes:
        return [null, [requiredConditionalValidator(question.required), validCustomValidators(question.validators), requiredOthers(question.flag_others_option)]];
      default:
        return [null, [requiredConditionalValidator(question.required), validCustomValidators(question.validators)]];
    }
  }

  formMatrizConfig(question: Questions) {
    let formArrayMatriz = this.formBuilder.array([]);
    let itemsMatriz = (question.answersOBJ as MatrizObj).items

    if (itemsMatriz.length > 0) {
      itemsMatriz.filter(x => x.deletedAt == null).forEach(item => {
        formArrayMatriz.push(this.formItemMatrizConfig(item, question.required))
      });
    }
    return formArrayMatriz;
  }

  formItemMatrizConfig(item: ArrayMatrizItems, isRequired: boolean) {
    return this.formBuilder.group({
      id: [item.id],
      value: [null, [requiredConditionalValidator(isRequired)]]
    })
  }

  verifyAudience(audience: SurveyAudiences) {
    this.form.get('fk_audience').setValue(audience.id_survey_audience);
    this.form.get('participant_key').setValue(audience.participant_key);
    this.form.get('name').setValue(audience.name);
    this.form.get('tags').setValue(audience.tags);
    this.form.get('comments').setValue(audience.comments);
    this.form.get('key_attendance').setValue(audience.key_attendance);
    this.form.get('fk_contact').setValue(audience.fk_contact);
    this.form.get('properties').setValue(audience.properties);
    this.form.get('anonymous').setValue(false);
  }

  validAudience(audience: SurveyAudiences) {
    if (audience == null) {
      this.surveyNotValid = true
      this.router.navigate(['survey-answered'])
      return false
    }
    return true;
  }

  // tradicionalFinishForm(finishFormType: finishFormEnum) {
  //   let response = new SurveysResponse();
  //   response = { ...this.form.value };
  //   response.responses = JSON.stringify(this.form.get('responses').value)
  //   if (typeof this.form.get('participant_key').value == 'object' && this.form.get('anonymous').value == false) {
  //     response.participant_key = response.participant_key['e164Number'].replace('+', '').toString();
  //   }
  //   if (!this.queryParamsUtils.isPreview) {
  //     this.surveyService.saveResponse(response).then(() => {
  //       this.redirectOnSuccess(finishFormType);
  //     }).catch(erro => console.log(erro));
  //   }
  // }

  finishForm(finishFormType: finishFormEnum, logicalRedirectThanks: any = null) {
    // if (!this.queryParamsUtils.isOfflineMode)
    //   this.tradicionalFinishForm(finishFormType)
    // else {
    let response = new SurveysResponse();

    //Logica para implementar o identification quando vem do audience e nao possui participant_key (Plugin feature)
    if(this.form.get('name_key').value == '' && this.form.get('participant_key').value == null && this.form.get('fk_contact').value != null)  this.form.get('name_key').setValue('identification');
    
    const redirectOBJ = this.getRedirectOBJ(finishFormType, logicalRedirectThanks)
    if(redirectOBJ.url !== null && redirectOBJ.timeRedirect !== null) this.form.get('url_redirected').setValue(redirectOBJ.url);
    response = { ...this.form.value };

    response.responses = JSON.stringify(this.form.get('responses').value);
    if (typeof this.form.get('participant_key').value == 'object' && this.form.get('anonymous').value == false && this.form.get('participant_key').value !== null) {
      response.participant_key = response.participant_key['e164Number'].replace('+', '').toString();
    }

    const saveResponseOnline = () => {
      if (!this.queryParamsUtils.isPreview) {
        this.surveyService.saveResponse(response).then(() => {
          if(redirectOBJ.url !== null && redirectOBJ.timeRedirect !== null)
            this.redirectFunction(redirectOBJ.url, redirectOBJ.timeRedirect)
        }).catch(error => console.log(error));
      }else {
        if(redirectOBJ.url !== null && redirectOBJ.timeRedirect !== null)
          this.redirectFunction(redirectOBJ.url, redirectOBJ.timeRedirect)
      }
    };

    const saveResponseOffline = () => {
      let offlineResponses = JSON.parse(localStorage.getItem('offlineResponses')) || [];
      offlineResponses.push(response);
      localStorage.setItem('offlineResponses', JSON.stringify(offlineResponses));
    };

    if (navigator.onLine) {
      saveResponseOnline();
    } else {
      saveResponseOffline();
    }
    // }
  }

  getRedirectOBJ = (finishFormType, logicalRedirectThanks) => {
    let objRedirect = { url: null, timeRedirect: null}
    if(finishFormType != finishFormEnum.Abandonment){
      if(logicalRedirectThanks != null)
      {
        objRedirect.url = logicalRedirectThanks.url;
        objRedirect.timeRedirect = logicalRedirectThanks.timeRedirect;
      }
      else if (this.survey.flag_redirect_thanks)
      {
        objRedirect.url = this.survey.url_redirect_thanks;
        objRedirect.timeRedirect = this.survey.time_redirect_thanks;
      }
    }

    return objRedirect;
  };

  redirectFunction(url, timeRedirect)
  {
    setTimeout(() => {
      const urlFormated = url.startsWith('https://') ? url : `https://${url}`;
      if(HelpersSettings.isInIframe()) {
        const newWindow = window.open(urlFormated, '_blank');
        newWindow.focus();
      } else {
        window.location.href = urlFormated;
      }
    }, timeRedirect * 1000);
  }

  syncOfflineResponses = () => {
    let offlineResponses = JSON.parse(localStorage.getItem('offlineResponses')) || [];
    if (offlineResponses.length > 0) {
      Promise.all(offlineResponses.map(res => this.surveyService.saveResponse(res)))
        .then(() => {
          localStorage.removeItem('offlineResponses');
          // ... restante do código ...
        }).catch(error => console.log(error));
    }
  }

  setOthersParameters(form_question_edit: FormGroup) {
    const type_question = form_question_edit.get('fk_type_question').value;
    if (type_question == 1) this.form.get('nps_value').setValue(form_question_edit.get('value').value);
    if (type_question == 2) this.form.get('nps_feedback').setValue(form_question_edit.get('value').value);
    form_question_edit.get('data_response').setValue(Helpers.date2str(new Date(), "yyyy-MM-dd hh:mm:ss"));
  }

  getDevice() {
    this.device = this.deviceDetector.getDeviceInfo();
    const isMobile = this.deviceDetector.isMobile();
    const isTablet = this.deviceDetector.isTablet();
    const isDesktopDevice = this.deviceDetector.isDesktop();
    this.device.devicetype = isMobile ? "Mobile" : isTablet ? "Tablet" : "Desktop";
    this.device.fk_audience = (this.queryParamsUtils.id_survey_audience != undefined) && (this.queryParamsUtils.id_survey_audience != "0") ? this.queryParamsUtils.id_survey_audience : null;
  }
}